import { LOADING_STATUSES } from '@yandex-int/k-common/client/api/constants';
import { createSelector } from 'reselect';

import { getClasses } from 'common.components/user/selectors';
import { getSavedTeamId } from 'utils/saved-team-id';
import { getSubjectFromProps } from 'utils/selectors/selectors';

import { Course } from '@yandex-int/k-common';
import { getAllCoursesList } from 'store/courses/selectors';
import { TeacherCoursesByClassState } from './typings';

export const teacherCoursesByClassSelector = (storeState: { teacherCoursesByClass: TeacherCoursesByClassState }) =>
    storeState.teacherCoursesByClass;

/**
 * gets ids of classes to load teacher courses
 * @example getClassesIdToLoad(storeState)
 */
export const getClassesIdToLoad = createSelector([teacherCoursesByClassSelector, getClasses], (state, classes) =>
    classes
        .filter((classItem) => {
            const classCourses = state.classes[classItem.id];
            return (
                !classCourses ||
                (classCourses.loadingStatus !== LOADING_STATUSES.SUCCESS &&
                    classCourses.loadingStatus !== LOADING_STATUSES.LOADING)
            );
        })
        .map((classItem) => classItem.id)
);

/**
 * gets classes which have current subject
 * @example getClassesWithCurrentSubject(storeState)
 */
export const getClassesWithCurrentSubject = createSelector(
    [teacherCoursesByClassSelector, getSubjectFromProps, getClasses],
    (state, subject, classes) =>
        classes.filter(
            (classItem) =>
                state.classes[classItem.id]?.list?.some((course) => course.subject === subject && !course.closed)
        )
);

/**
 * gets is any class course loading
 * @example getAreClassCoursesLoading(storeState)
 */
export const getAreClassCoursesLoading = createSelector([teacherCoursesByClassSelector], (state) =>
    Object.values(state.classes).some((classCourses) => classCourses.loadingStatus === LOADING_STATUSES.LOADING)
);

/**
 * gets is all class courses loaded
 */
export const getIsClassCoursesRequestSuccess = createSelector(
    [teacherCoursesByClassSelector],
    (state) => state.requestLoadingStatus === LOADING_STATUSES.SUCCESS
);

const getDoesCourseContainsSubject = (courses: Course[], subject: string) => {
    for (let course of courses) {
        if (course.subject === subject) {
            return true;
        }
    }
    return false;
};

/**
 * Находит `id` класса (текущего или первого из списка), в котором есть переданный урок
 */

export const getCurrentOrFirstTeamIdWithSubject = createSelector(
    [getAllCoursesList, getSubjectFromProps, getSavedTeamId],
    (courseList, subject, savedTeamId) => {
        // проверка сохраненного класса
        const allAvailableCoursesForTeam = courseList[Number(savedTeamId)];
        if (
            savedTeamId &&
            allAvailableCoursesForTeam &&
            getDoesCourseContainsSubject(allAvailableCoursesForTeam.list, subject)
        ) {
            return Number(savedTeamId);
        }

        return null;
    }
);

/**
 * Есть ли у учителя активный класс с информатикой
 *
 * @deprecated используйте `store/courses/selectors -> getIsInformaticsTeacher`
 */
export const getIsInformaticsTeacher = createSelector(
    [(store) => getCurrentOrFirstTeamIdWithSubject(store, { subject: 'informatics' })],
    (teamId) => !!teamId
);
